{
	"features/pdf-generation": {
		"fallObservationDetails": {
			"causes": {
				"label": "Oorzaken"
			},
			"consequences": {
				"label": "Gevolgen"
			},
			"contexts": {
				"label": "Context"
			},
			"correctiveActions": {
				"label": "Correctieve acties"
			},
			"location": {
				"label": "Plaats"
			},
			"notes": {
				"label": "Notities"
			},
			"observedOn": {
				"label": "Tijdstip van de observatie"
			},
			"occurredOn": {
				"label": "Tijdstip van de gebeurtenis"
			},
			"title": "Details"
		},
		"footer": {
			"export": "Geëxporteerd door {{user}} op {{exportDate}} om {{exportTime}}",
			"numbered": "Pagina {{page}} van {{total}}"
		},
		"header": {
			"title": "Vaststelling en opvolging valincident",
			"topHeader": "Geregistreerd door {{creator}} op {{creationDate}} om {{creationTime}}"
		},
		"linkedObservations": {
			"noLinkedObservations": "Geen gekoppelde observaties gevonden.",
			"table": {
				"causedBy": "Oorzaak",
				"consequence": "Gevolg",
				"header": {
					"occurredOn": "Tijdstip van de gebeurtenis",
					"type": "Type"
				}
			},
			"title": "Gekoppelde observaties"
		},
		"resident": {
			"firstName": {
				"label": "Voornaam"
			},
			"lastName": {
				"label": "Naam"
			},
			"title": "Resident"
		},
		"restrictiveMeasures": {
			"applicationApproval": {
				"fileNamePrefix": "VBM_akkoord voor toepassing",
				"mainTitle": "Akkoord voor toepassing"
			},
			"dateLabel": "datum",
			"detailsLabel": "Uitvoeringsdetails",
			"discontinuationApproval": {
				"fileNamePrefix": "VBM_akkoord voor stopzetting",
				"mainTitle": "Akkoord voor stopzetting"
			},
			"doctorSignature": {
				"applicationText": "Ik, ondergetekende, …………………………………….................................................., behandelende arts van ……………………………….........................................................................................., verklaar hierbij dat ik de bovenstaande maatregelen noodzakelijk acht.",
				"discontinuationText": "Ik, ondergetekende, …………………………………….................................................., behandelende arts van ……………………………….........................................................................................., verklaar hierbij dat ik akkoord ga met de stopzetting van de bovenstaande maatregelen.",
				"title": "Akkoord van de behandelende arts"
			},
			"evaluationDateLabel": "Datum evaluatie",
			"followUpPlanLabel": "Opvolgplan",
			"header": {
				"createdBy": "Document aangemaakt op {{date}} om {{time}} door {{user}}",
				"smallTitle": "Medisch akkoord vrijheidsbeperkende maatregelen"
			},
			"reasonLabel": "Reden",
			"residentSignature": {
				"applicationText": "Ik, ondergetekende, ………………………………………................................................................................. verklaar hierbij dat ik geïnformeerd werd over de toepassing van de bovenstaande maatregelen bij ….………………………................................................................................................................................…….. ",
				"discontinuationText": "Ik, ondergetekende, ………………………………………................................................................................. verklaar hierbij dat ik akkoord ga met de stopzetting van de bovenstaande maatregelen bij ………………………................................................................................................................................…….. ",
				"title": "Kennisgeving aan de resident, familie of wettelijk vertegenwoordiger"
			},
			"signatureLabel": "handtekening"
		},
		"signature": {
			"label": "Handtekening verzorgende die valincident heeft geregistreerd"
		}
	}
}
